<template>
  <v-dialog
    :value="showing"
    width="800px"
    @input="onClose"
    content-class="dialog-center-margin"
  >
    <DeviationApprovalModal
      v-model="deviationApprovalModalShowing"
      :event-id="deviationApprovalModalId"
      @close="onHideDeviationApprovalModal"
      @deviationApproved="$emit('deviationApproved')"
    />
    <AddNoteModal
      v-model="addNoteModalShowing"
      :event-id="addNoteModalEventId"
      @close="onHideAddNoteModal"
    />
    <div class="primary pa-6 white--text d-flex justify-space-between align-center">
      <span>{{ task ? task.name : '' }}</span>
      <VIcon style="color: white;cursor:pointer;" medium @click="onClose">mdi-close</VIcon>
    </div>
    <div class="white px-6 py-4 marker-container">
      <div v-for="(item, index) in events" :key="index" class="marker-item">
        <div class="marker-left">
          <div
            :class="item.type === 'fulfilled' || item.approvedBy ? 'status-green' : 'status-red'"
            class="text-status">{{
            item.type === 'fulfilled' ? $t('Fulfilled') :
            item.approvedBy ? `${$t('Approved by')} ${item.approvedBy.name}` :
            $t('Deviation')
            }}</div>
          <div class="text-time">
            {{dateToHumanTime((item.click && item.click.timestamp) || item.timestamp)}}
          </div>
        </div>
        <div class="marker-right">
          <div class="d-flex flex-column">
            <div class="note-container">
              <div v-for="note in item.notes" :key="note.id" class="note-item">
                <div class="note-author">
                  {{$t('Note by')}} {{note.user.name}}
                </div>
                <div class="note-timestamp">
                  {{format(parseISO(note.timestamp),
                  'do MMM yyyy HH:mm', { locale: getLanguagePackFromBrowser() })
                  }}
                </div>
                <div class="note-text">{{note.text}}</div>
              </div>
            </div>
            <v-btn
              class="add-note-button"
              text
              color="primary"
              small
              @click="showAddNoteModal(item)"
            >{{ $t('Add note') }}</v-btn>
          </div>
          <div
            v-if="showDeviationApprovalButton(item)"
            class="d-flex justify-end fill-height align-center"
          >
            <v-btn @click="showDeviationApprovalModal(item)">{{$t('Approve')}}</v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>

import { format, parseISO } from 'date-fns';
import { getLanguagePackFromBrowser } from '../../globals/helpers/language';
import DeviationApprovalModal from './DeviationApprovalModal.vue';
import AddNoteModal from './AddNoteModal.vue';

export default {
  name: 'MarkerInfoModal',
  components: {
    DeviationApprovalModal,
    AddNoteModal,
  },
  props: {
    showing: {
      type: Boolean,
      required: true,
      default: false,
    },
    task: {
      type: Object,
      required: false,
    },
    events: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      deviationApprovalModalShowing: false,
      deviationApprovalModalId: null,
      addNoteModalShowing: false,
      addNoteModalEventId: null,
    };
  },
  methods: {
    format,
    parseISO,
    getLanguagePackFromBrowser,
    onClose() {
      this.$emit('close');
    },
    showDeviationApprovalButton(item) {
      return item.type !== 'fulfilled' && !item.approvedBy;
    },
    showDeviationApprovalModal(item) {
      this.deviationApprovalModalId = item.id;
      this.deviationApprovalModalShowing = true;
    },
    showAddNoteModal(item) {
      this.addNoteModalEventId = item.id;
      this.addNoteModalShowing = true;
    },
    onHideDeviationApprovalModal() {
      this.deviationApprovalModalShowing = false;
      this.deviationApprovalModalId = null;
    },
    onHideAddNoteModal() {
      this.addNoteModalShowing = false;
      this.addNoteModalEventId = null;
    },
    dateToHumanTime(date) {
      return format(date, 'HH:mm');
    },
  },
};
</script>

<style scoped>
  .marker-container {
    display: flex;
    flex-direction: column;
  }

  .marker-item {
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  .marker-item:not(:last-child) {
    margin-bottom: 24px;
  }

  .marker-item:not(:last-child)::after {
    content: '';
    display: block;
    position: absolute;
    bottom: -9px;
    height: 2px;
    left: 2%;
    width: 96%;
    background-color: #eee;
  }

  .marker-left {
    width: 300px;
    padding-right: 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .marker-right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .text-status {
    background-color: #ccc;
    height: 20px;
    border-radius: 10px;
    padding: 0px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: inline-block;
    color: #fff;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  }

  .status-green {
    background-color: #94D093;
  }

  .status-red {
    background-color: #FF7245;
  }

  .text-time {
    font-size: 26px;
  }

  .note-item:not(:last-child) {
    margin-bottom: 12px;
  }

  .note-author {
    color: #aaa;
    font-size: 14px;
  }

  .note-timestamp {
    font-size: 12px;
    color: #aaa;
    margin-top: -4px;
  }

  .note-text {
    font-size: 14px;
  }

  .add-note-button {
    font-size: 14px;
    align-self: flex-end;
    margin-top: 12px;
  }
</style>
